import { request } from './request';
import * as PATHS from '@/constants/path';
import { URLParamBuilder } from '@/utils/functions';

export function setUiPreferencesRequest({
                                   params,
                                   data = {}
                                 }) {
  const url = URLParamBuilder(PATHS.UI_PREFERENCES, {params})
  return request(url, {
    method: 'PUT',
    data
  });
}
export function setPartnerPreferencesRequest({
                                   params,
                                   data = {}
                                 }) {
  const url = URLParamBuilder(PATHS.SET_PARTNER_PREFERENCES, {params})
  return request(url, {
    method: 'PUT',
    data
  });
}

export function fetchUiPreferencesRequest() {
  return request(PATHS.FETCH_UI_PREFERENCES, {
    method: 'GET'
  });
}

export function fetchPartnerConfigRequest() {
  return request(PATHS.FETCH_PARTNER_CONFIG, {
    method: 'GET'
  });
}

export function setPartnerConfigRequest({data}) {
  return request(PATHS.SET_PARTNER_CONFIG, {
    method: 'PUT',
    data
  });
}

export function fetchPartnerUserIntegrationsRequest() {
  return request(PATHS.FETCH_PARTNER_INTEGRATIONS, {
    method: 'GET'
  });
}

export function fetchIntegrationTypesRequest() {
  return request(PATHS.FETCH_INTEGRATION_TYPES, {
    method: 'GET'
  });
}
